"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const ApiConstants = {
  API_RESPONSE: {
    SUCCESS: "SUCCESS",
    FAIL: "FAIL",
    INVALID_ANNOTATION_ID: "INVALID_ANNOTATION_ID",
    INVALID_ANNOTATION: "INVALID_ANNOTATION",
    INVALID_PAGE_RANGE: "INVALID_PAGE_RANGE",
    INVALID_CONFIG: "INVALID_CONFIG",
    INVALID_ANNOTATION_MODE: "INVALID_ANNOTATION_MODE",
    INVALID_OPTIONS: "INVALID_OPTIONS",
    INVALID_INPUT: "INVALID_INPUT",
    IGNORE_FAIL: "IGNORE_FAIL",
    FILE_MODIFIED: "FILE_MODIFIED",
    PREVIEW_RENDERING_FAILED: "PREVIEW_RENDERING_FAILED",
    USER_CANCELLED: "USER_CANCELLED",
    INVALID_THUMBNAIL_FORMAT: "INVALID_THUMBNAIL_FORMAT",
    INVALID_ZOOM_LEVEL: "INVALID_ZOOM_LEVEL"
  },
  CUSTOMIZABLE_PANEL: Object.freeze({
    HUD: 0,
    LHP: 1,
    TOP_BAR: 2,
    DOCUMENT: 3,
    PAGED_VIEW_STATE: 4,
    QUICK_TOOLS: 5,
    CONTEXT_MENU: 6,
    SKINNY_RAIL: 7
  }),
  CONTEXT_MENU_TRIGGER_TYPE: Object.freeze({
    RIGHT_CLICK: "rightClick",
    TEXT_SELECTION: "textSelection",
    TOUCH_AND_HOLD_EMPTY_SPACE: "touchAndHoldEmptySpace"
  }),
  RHP_POSITION_TYPE: Object.freeze({
    TOP: "top",
    BOTTOM: "bottom"
  }),
  SEARCH_ADDON_TRIGGER: Object.freeze({
    ON_FOCUS: "ON_FOCUS",
    // Shows Promo only when Search Box is focused
    ALWAYS: "ALWAYS" // Always show Promo Panel when Search Box is visible
  }),
  EXTERNAL_OVERLAY_PREFIX: "external_"
};
var _default = exports.default = ApiConstants;